import "../../assets/css/agent.scss";
import logoBlue from "../../assets/images/logo_blue.png";
import { useEffect, useState } from "react";
import { SessionStorageUtil } from "../../utils/session_storage_util";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

function AgentResultPage() {
  const [searchParams] = useSearchParams();
  const kdBusiness = searchParams.get("kd_business");
  const navigate = useNavigate();
  const location = useLocation();
  const [businessCode, setBusinessCode] = useState("");

  const handleCopy = () => {
    navigator.clipboard
      .writeText(businessCode)
      .then(() => {
        alert("영업 코드가 복사되었습니다!");
      })
      .catch(() => {
        alert("복사에 실패했습니다. 다시 시도해주세요.");
      });
  };

  useEffect(() => {
    if (!kdBusiness || !SessionStorageUtil.getItem("accessToken")) {
      navigate(-1);
    }
  }, [kdBusiness]);

  useEffect(() => {
    setBusinessCode(`?kd_business=${location.state?.salesManCode}`);
  }, [location]);

  return (
    <div className="agent-container">
      <div className="agent-main">
        <div className="agent-content">
          <div className="logo-section">
            <div className="logo-text">
              <img src={logoBlue} alt="" />
            </div>
          </div>

          <div className="result-section">
            <h1 className="result-title">에이전트 관리자</h1>
            <p className="result-subtitle">
              에이전트가 성공적으로 등록되었습니다
            </p>

            <div className="business-code-section">
              <label className="business-code-label">
                영업 코드 (아래 코드를 복사하여 사용하세요)
              </label>
              <div className="business-code-display">{businessCode}</div>
            </div>

            <button className="copy-button" onClick={handleCopy}>
              복사하기
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AgentResultPage;
